export const cleanEmptyString = (input: string) => input.replace(/^\s+$/, '');

export const trimConsecutiveWhiteSpaces = (input: string) =>
    input.replaceAll(/\s+/g, ' ');

export const trimTrailingWhiteSpaces = (input: string) =>
    input.replace(/\s+$/, '');

export const trimWhiteSpaces = (input: string) => input.replaceAll(/\s/g, '');
